export interface ParticipantInfo {
  membershipId: string
  employeeId: string
  employeeName: string
}

export type FileUploadStatus = 'pending' | 'uploading' | 'success' | 'error'

// File upload status constants - single source of truth
export const FileStatus = {
  PENDING: 'pending',
  UPLOADING: 'uploading',
  SUCCESS: 'success',
  ERROR: 'error',
} as const satisfies Record<string, FileUploadStatus>

export interface FileUpload {
  id: string
  file: File
  signedId: string | null
  progress: number
  status: FileUploadStatus
  error?: string
}

export interface ParticipantFiles {
  membershipId: string
  employeeId: string
  employeeName: string
  files: FileUpload[]
}

export type ParticipantFilesMap = Map<string, ParticipantFiles>

export interface MembershipWithSignedIds {
  membershipId: string
  signedIds: string[]
}
